<template>
  <div class="dt">
    <div id="bddt">
    </div>
  </div>
</template>

<script>
export default {
  name: 'lxdt',
  mounted () {
    if (sessionStorage.getItem('bddt') - 0 === 1) {
      sessionStorage.setItem('bddt', 0)
      setTimeout(_ => {
        window.history.go(0)
      }, 0)
    }
  }
}
</script>

<style scoped>
.dt {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}
#bddt {
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Lxdt.vue